import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import StackItem from './stack-item';

class TeamStack extends Component {
    rangeControlledByNamePositions() {
        const {sportConfig} = this.props;
        return sportConfig.getConfigProp('rangeControlledByNamePositions', []);
    }

    getRangePositions() {
        let arr = [];
        this.rangeControlledByNamePositions().map((item) => {
            arr.push(
                <option key={item} value={item}>
                    {item}
                </option>,
            );
        });
        return arr;
    }

    setPlayersInGroup(groupNumber = null, value = null) {
        this.props.dispatch(Action.set('NHLNameStackPayersInGroup', groupNumber, value));
    }

    addItem() {
        const {groupNumber} = this.props;
        this.props.dispatch(Action.do('addNHLNameStackItem', groupNumber));
    }

    render() {
        const {groupNumber, stack} = this.props;
        let rangePositions = this.getRangePositions();
        let group = stack.groups[groupNumber];

        return (
            <div className="team-stack">
                <h3>STACK {groupNumber}</h3>
                <div className="form-inline mb5">
                    <div className="form-sub-text">
                        <strong>Stack {groupNumber} players</strong>
                    </div>
                    <select
                        value={group.playersQuantity}
                        onChange={(e) => ::this.setPlayersInGroup(groupNumber, e.target.value)}
                        className="form-control input-sm"
                    >
                        {rangePositions}
                    </select>
                </div>
                <div className="gap-y">
                    {group.items.map((item, index) => {
                        return <StackItem key={index} item={item} groupNumber={groupNumber} itemNumber={index} />;
                    })}
                </div>
                <div className="text-right">
                    <button type="submit" onClick={::this.addItem} className="btn">
                        Add team
                    </button>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, stacks} = state;
    return {
        sportConfig,
        stack: stacks.nhlName,
    };
}

export default connect(mapStatesToProps)(TeamStack);
